import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image, TextInput } from '../types'
import { CmsConverterService, defaultTextInput } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class PlainTeaserSplitConverter extends CmsConverterService<PlainTeaserSplitData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_image_title_text?.value
    const altText = formData.st_image_alt_text?.value
    const lazyLoad = formData.st_lazy_load_image?.value
    return {
      headline: formData.st_headline ?? defaultTextInput,
      text: formData.st_text ?? defaultTextInput,
      image: CmsConverterService.mapImage(formData.st_image, lazyLoad, altText, title),
      bgColor: formData.st_backgroundcolor?.value?.identifier ?? 'white',
      imageRight: formData.st_image_in_right_box?.value ?? false
    }
  }
}

export const PLAIN_TEASER_SPLIT_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, PlainTeaserSplitData>>(
  'PlainTeaserSplitConverter')

export interface PlainTeaserSplitData extends ConvertedComponentData {
  headline: TextInput;
  text: TextInput;
  image: Image;
  bgColor: string;
  imageRight: boolean;
}
